import { render, staticRenderFns } from "./SectionsSessionLogo.vue?vue&type=template&id=31b6c2f8&scoped=true&"
import script from "./SectionsSessionLogo.vue?vue&type=script&lang=js&"
export * from "./SectionsSessionLogo.vue?vue&type=script&lang=js&"
import style0 from "./SectionsSessionLogo.vue?vue&type=style&index=0&id=31b6c2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b6c2f8",
  null
  
)

export default component.exports